export { default } from './FeaturedServices';
